import { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;

  & strong {
    color: #e74c3c;
  }

  .select {
    height: 38px;
    border: 1px solid #ececec;
    border-radius: 10px;
    padding-left: 20px;
    :focus {
      border-color: #3bb77e !important;
      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
    }
  }

  .modal-section {
    position: fixed;
    top: 15vh;
    left: 30vw;
    width: 40vw;
    height: 70vh;
    background-color: white;
    border-radius: 20px;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;
    & > i {
      font-size: 2rem;
      color: black;
      cursor: pointer;
      :hover {
        color: #3bb77e;
      }
    }
    @media screen and (max-width: 1199px) {
      left: 25vw;
      width: 50vw;
    }
    @media screen and (max-width: 767px) {
      left: 15vw;
      width: 70vw;
    }
    @media screen and (max-width: 575px) {
      left: 10vw;
      width: 80vw;
    }
  }

  .modal-header {
    font-size: 1.2rem;
    font-weight: 500;
    color: black;
    & i {
      font-size: 26px !important;
      color: #696969;
      cursor: pointer;
      :hover {
        color: #3bb77e;
      }
    }
  }

  .modal-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: none;
    margin: 0 auto;
    overflow-y: auto;
    & > span {
      color: black;
    }
  }
  .inputWrapper {
    width: 100%;
    margin-bottom: 20px;

    & h6 {
      margin-bottom: 10px;
    }
    & input {
      height: 38px;
      margin-bottom: 10px;
      ::placeholder {
        font-size: 14px;
        color: #6c757da5;
      }
      :focus {
        border-color: #3bb77e !important;
        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
      }
    }
    .col {
      display: flex;
      flex-direction: column;
      width: 50%;
      & input {
        width: 100%;
        padding-right: 0;
      }
    }
    @media screen and (max-width: 575px) {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      .row {
        display: flex;
        flex-direction: column;
        .col {
          width: 100%;
        }
      }
    }
  }
  & textarea {
    min-height: 150px;
    ::placeholder {
      font-size: 14px;
      color: #6c757da5;
    }
    :focus {
      border-color: #3bb77e !important;
      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
    }
  }
  .btnWrapper {
    width: 100%;
    & button {
      width: 100%;
    }
  }
`;

const FileWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
  row-gap: 10px;
  & input {
    padding: 6px 5px;
  }
  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const ProductInquiryModal = ({
  onClickInquiry,
  submitInquiry,
  openInquiryModal,
  onChangeInquiry,
  inquiryInputs,
}) => {
  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return onClickInquiry();
  };

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="modal-header">
            제작 & 상품 문의
            <i className="fi-rs-circle-cross" onClick={onClickInquiry} />
          </div>
          <div className="modal-content">
            <div className="inputWrapper">
              <div className="row">
                <div className="col">
                  <h6>
                    문의 분류 <strong>(필수)</strong>
                  </h6>
                  <select
                    className="select mb-10"
                    defaultValue={""}
                    onChange={onChangeInquiry("division")}
                  >
                    <option disabled value={""}>
                      --선택하세요--
                    </option>
                    <option value={"M"}>제작 문의</option>
                    <option value={"Q"}>상품 문의</option>
                  </select>
                </div>
                <div className="col">
                  <h6>회사명</h6>
                  <input type="text" onChange={onChangeInquiry("company")} />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>
                    문의자 명 <strong>(필수)</strong>
                  </h6>
                  <input type="text" onChange={onChangeInquiry("name")} />
                </div>
                <div className="col">
                  <h6>
                    문의자 연락처 <strong>(필수)</strong>
                  </h6>
                  <input type="text" onChange={onChangeInquiry("tel")} />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>
                    이메일 <strong>(필수)</strong>
                  </h6>
                  <input type="text" onChange={onChangeInquiry("email")} />
                </div>
                <div className="col">
                  <h6>인쇄 여부 </h6>
                  <div className="d-flex custome-radio justify-content-around align-items-center h-50">
                    <input
                      className="d-none"
                      type={"radio"}
                      id="yes"
                      name="printRadio"
                      value="Y"
                      onChange={onChangeInquiry("printYn")}
                    />
                    <label className="form-check-label" htmlFor="yes">
                      예
                    </label>
                    <input
                      className="d-none"
                      type={"radio"}
                      id="no"
                      name="printRadio"
                      value="N"
                      onChange={onChangeInquiry("printYn")}
                    />
                    <label className="form-check-label" htmlFor="no">
                      아니요
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>사용처</h6>
                  <input type="text" onChange={onChangeInquiry("usages")} />
                </div>
                <div className="col">
                  <h6>수량</h6>
                  <input type="text" onChange={onChangeInquiry("cnt")} />
                </div>
              </div>
              <h6>문의 내용</h6>
              <textarea
                type="text"
                onChange={onChangeInquiry("content")}
                placeholder="문의 내용을 자세하게 입력해주세요."
              />
              <div className="row">
                <div className="col">
                  <h6>첨부 파일</h6>
                  <FileWrapper>
                    <input
                      type="file"
                      className="form-control"
                      onChange={onChangeInquiry("file1")}
                    />
                    <input
                      type="file"
                      className="form-control"
                      onChange={onChangeInquiry("file2")}
                    />
                    <input
                      type="file"
                      className="form-control"
                      onChange={onChangeInquiry("file3")}
                    />
                  </FileWrapper>
                </div>
              </div>
            </div>
            <div className="btnWrapper">
              <button className="btn" onClick={submitInquiry}>
                문의하기
              </button>
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};
export default ProductInquiryModal;
